import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState } from 'react';
import OrderListArea from "@/pages/comp/book_order/shop/order/acommon/list";
import ListMonthArea from "@/pages/comp/book_order/shop/order/acommon/list_month";
import ShopManagerListArea from "@/pages/comp/book_order/shop/manager/acommon/list";
import SelectTab from "@/pcomponents/common/crud/write/select_tab";

function BookOrderListPage() {
  const [page_tab, set_page_tab] = useState("list");//"list_month"
  let page_tab_arr = [
    { text: "내역", value: "list" },
    { text: "월별내역", value: "list_month" },
    { text: "관리자", value: "manager" },
  ];
  return (
    <CompLayout>
      <div>
        <div style={{ display: "inline-block" }}>
          <SelectTab
            select_arr={page_tab_arr}
            value={page_tab}
            is_same_value_empty={false}
            on_select={(value: string) => {
              set_page_tab(value);
            }}
            item_style={{ padding: "0px 12px", fontSize: "15px" }}
          ></SelectTab>
        </div>
      </div>
      <div className="mt-1">
        {page_tab == "list" &&
          <OrderListArea></OrderListArea>
        }
        {page_tab == "list_month" &&
          <ListMonthArea></ListMonthArea>
        }
        {page_tab == "manager" &&
          <ShopManagerListArea></ShopManagerListArea>
        }
      </div>
    </CompLayout>
  );
}

export default BookOrderListPage;